module.exports = __webpack_public_path__ + "2cb6a97a9885a9709084f0329ed2fe8c.mp4";